import React from 'react'
import { organizationColumn, progressColumn } from '../shared/BulkEditColumns'
import { massPlaybookUpdateProgressStatus } from '../../playbook.helpers'
import SelectCategory from './SelectCategory'

const columns = (section, columnsNo) => [
  {
    label: 'Playbook',
    accessor: 'config_name',
    format: (value, row) => (
      <div className="preview-name-column" style={{ maxWidth: columnsNo < 3 ? '300px' : '200px' }}>
        <a
          href={`/playbooks/${row.config_id}/${section}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {value}
        </a>
      </div>
    ),
  },
  {
    label: 'Name',
    accessor: 'content',
    format: (value) => (
      <div className="preview-content-column">
        <span>{value}</span>
      </div>
    ),
  },
  {
    label: 'Trigger Type',
    accessor: 'triggerType',
  },
  {
    label: 'Side',
    accessor: 'side',
  },
]

const selectCategoryColumn = {
  label: 'Category',
  accessor: 'configIdOriginal',
  format: (value) => <SelectCategory playbookId={value} />,
}

export const getColumns = (isUpdate, progress, showOrgs, section) => {
  const columnsNo = 1 + (isUpdate ? 3 : 1) + (showOrgs ? 1 : 0)
  let cols = [...columns(section, columnsNo)]
  if (showOrgs) {
    const [first, ...rest] = cols
    cols = [first, organizationColumn, ...rest]
  }
  if (progress !== massPlaybookUpdateProgressStatus.INITIAL) {
    cols = [progressColumn, ...cols]
  }
  if (!isUpdate) {
    // Remove Name, Trigger Type and Side columns
    cols = cols.filter((col) => !['Name', 'Trigger Type', 'Side'].includes(col.label))
    // Add `Category` column with dropdown
    cols.push(selectCategoryColumn)
  }
  return cols
}
